const DataGrid = (theme) => {
  const headerBg = theme.palette.customColors.tableHeaderBg;
  const rowHover = "rgba(30, 58, 95, 0.04)";

  return {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 0,
          color: theme.palette.text.primary,
          fontSize: "0.875rem",
          backgroundColor: theme.palette.background.paper,
          "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
            {
              outline: "none",
            },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
        },
        toolbarContainer: {
          paddingRight: `${theme.spacing(3)} !important`,
          paddingLeft: `${theme.spacing(3)} !important`,
          backgroundColor: theme.palette.customColors?.tableHeaderBg || theme.palette.grey[50],
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        columnHeaders: {
          backgroundColor: `${headerBg} !important`,
          borderRadius: 0,
          borderBottom: `1px solid ${theme.palette.divider}`,
          minHeight: "48px !important",
          maxHeight: "48px !important",
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: `${headerBg} !important`,
          },
        },
        columnHeader: {
          color: `${theme.palette.text.primary} !important`,
          "&:not(.MuiDataGrid-columnHeaderCheckbox)": {
            padding: theme.spacing(1.25, 2),
            "&:first-of-type": {
              paddingLeft: theme.spacing(2),
            },
          },
          "&:last-of-type": {
            paddingRight: theme.spacing(2),
          },
        },
        columnHeaderTitleContainer: {
          padding: 0,
          color: `${theme.palette.text.primary} !important`,
        },
        columnHeaderTitle: {
          color: `${theme.palette.text.secondary} !important`,
          fontSize: "0.75rem",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: 1.4,
          letterSpacing: "0.02em",
        },
        columnSeparator: {
          color: theme.palette.divider,
        },
        row: {
          "&:hover": {
            backgroundColor: rowHover,
          },
          "&:last-child": {
            "& .MuiDataGrid-cell": {
              borderBottom: 0,
            },
          },
        },
        cell: {
          borderColor: theme.palette.divider,
          fontSize: "0.875rem",
          "&:not(.MuiDataGrid-cellCheckbox)": {
            padding: theme.spacing(1.25, 2),
            "&:first-of-type": {
              paddingLeft: theme.spacing(2),
            },
          },
          "&:last-of-type": {
            paddingRight: theme.spacing(2),
          },
          "&:focus, &:focus-within": {
            outline: "none",
          },
        },
        editInputCell: {
          padding: 0,
          color: theme.palette.text.primary,
          "& .MuiInputBase-input": {
            padding: 0,
          },
        },
        footerContainer: {
          minHeight: "48px !important",
          borderTop: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          "& .MuiTablePagination-toolbar": {
            minHeight: "48px !important",
          },
          "& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel":
            {
              color: theme.palette.text.secondary,
              fontSize: "0.8125rem",
            },
        },
      },
      defaultProps: {
        rowHeight: 52,
        headerHeight: 48,
      },
    },
  };
};

export default DataGrid;
